import * as React from "react";
const SvgUserFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M18.729 15.671A8 8 0 0 0 4 20a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1 7.97 7.97 0 0 0-1.271-4.329" }));
export default SvgUserFill;
